import React, {Component} from 'react';
import PropTypes from 'prop-types';
const { URL } = window;
export default class LinkedInIcon extends Component{
    constructor(props){
        super(props);
    }

    render(){
        const { title } = document;
        let docUrl = new URL(document.location);
        
        let targetUrl = new URL("https://www.linkedin.com/shareArticle");
        targetUrl.searchParams.set("url",docUrl.href);
        targetUrl.searchParams.set("title",title);
        targetUrl.searchParams.set("source","MedscapeTV");


        const aProps = {
            href: targetUrl.href,
            target: "_blank",
            onClick: this.props.onClick
        }
        return(
            <div className="facebook-icon icon-container">
                <a {...aProps}>
                    <span className="icon-title">LinkedIn</span>
                    <svg width="12" height="12" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g transform="translate(-156.000000, -995.000000)" fill="#1B7DB2">
                                <g transform="translate(115.000000, 954.000000)">
                                    <path d="M41.153,53 L43.7246667,53 L43.7246667,44.9032572 L41.153,44.9032572 L41.153,53 Z M42.4556667,41 C41.5755,41 41,41.6043517 41,42.3988169 C41,43.1761893 41.5591667,43.798157 42.4218333,43.798157 L42.4388333,43.798157 C43.336,43.798157 43.8938333,43.1761893 43.8938333,42.3988169 C43.877,41.6043517 43.336,41 42.4556667,41 L42.4556667,41 Z M53,48.3568698 L53,53 L50.4276667,53 L50.4276667,48.6682025 C50.4276667,47.5801951 50.056,46.8375314 49.125,46.8375314 C48.414,46.8375314 47.9915,47.3375823 47.8053333,47.8219357 C47.7376667,47.9949565 47.72,48.2354762 47.72,48.478089 L47.72,53 L45.1471667,53 C45.1471667,53 45.1816667,45.6628392 45.1471667,44.9032572 L47.72,44.9032572 L47.72,46.0505661 C47.7148333,46.0594613 47.7076667,46.0683566 47.7031667,46.0770774 L47.72,46.0770774 L47.72,46.0505661 C48.0618333,45.500109 48.6718333,44.7131437 50.0383333,44.7131437 C51.7311667,44.7131437 53,45.8700455 53,48.3568698 L53,48.3568698 Z"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                </a>
            </div>
        )
    }
    static get propTypes() {
        return {
            onClick: PropTypes.func
        }
    }

    static get defaultProps() {
        return {
            onClick: () => {}
        }
    }
}
